import './Solutions.css';
import Icon from './Icon';
import useReveal from './useReveal';

// §5.03 — all 12 program titles verbatim, grouped into three themed cards.
// Group labels are presentational; each card carries a brand icon (no tick bullets).
const GROUPS = [
  {
    num: '01',
    label: 'Communication & Presence',
    icon: 'role-play',
    items: [
      'Effective Business Communication',
      'Executive Presence & Professional Etiquette',
      'Presentation & Public Speaking Skills',
      'Sales & Client Communication',
    ],
  },
  {
    num: '02',
    label: 'Leadership & Teams',
    icon: 'bar-growth',
    items: [
      'Leadership Development',
      'Team Collaboration & Emotional Intelligence',
      'Conflict Resolution & Difficult Conversations',
      'Stress Management',
      'Workplace Productivity & Professional Effectiveness',
    ],
  },
  {
    num: '03',
    label: 'Workplace Culture & Compliance',
    icon: 'award-ribbon',
    items: [
      'Customer Service Excellence',
      'POSH Awareness & IC Capacity Building',
      'POCSO Awareness & Safe Workplace Practices',
      'Customised Learning & Development Programmes',
    ],
  },
];

export default function Solutions() {
  const gridRef = useReveal({ stagger: 90, maxStaggered: 3 });

  return (
    <section id="programs" className="solutions">
      <div className="container">
        <header className="solutions__header">
          <h2 className="solutions__title">What we offer</h2>
          <p className="solutions__sub">
            Practical training and professional development, for organisations, institutions and individuals.
          </p>
        </header>

        <div className="solutions__grid" ref={gridRef}>
          {GROUPS.map((group) => (
            <article className="solution-card reveal--scale" key={group.num}>
              <div className="solution-card__top">
                <span className="solution-card__icon" aria-hidden="true">
                  <Icon name={group.icon} size={26} strokeWidth={1.7} />
                </span>
              </div>
              <h3 className="solution-card__title">{group.label}</h3>
              <ul className="solution-card__list">
                {group.items.map((item) => (
                  <li className="solution-card__item" key={item}>{item}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
